export default __webpack_public_path__ + "static/media/raviz.f024a46f.svg";